import React, {useState, useEffect} from "react";
import {useSelector, useDispatch} from "react-redux";
import {withTranslation} from "react-i18next";
import {useTranslation} from "react-i18next";
import './cervoGame.scss';
import variables from "../../../../_constants/variables";
import localOrSessionStore from "../../../../_helpers/localOrSessionStore";
import {Button, Col, Modal, Progress, Row} from "antd";
import {history} from "../../../../_helpers";
import {LeftOutlined, RedoOutlined, UndoOutlined, ArrowRightOutlined, QuestionCircleOutlined} from "@ant-design/icons";
import Headerbutton from "../../component/headerButton";
import {questionnaireActions} from "../../../../_actions";
import have from "../../../../assets/img/have.png";
import like from "../../../../assets/img/like.png";
import then from "../../../../assets/img/then.png";
import study from "../../../../assets/img/study.png";
import work from "../../../../assets/img/work.png";
import {xcService} from "../../../../_services/xcService";


function CervoGame(props) {

    const dispatch = useDispatch();
    const storage = localOrSessionStore({key: variables.REMEMBER});
    const user = JSON.parse(storage.getItem(variables.USER));
    const {t, i18n} = useTranslation();
    const [step, setStep] = useState(-1);

    const [subStep, setSubStep] = useState(0);
    const [fSelect, setfSelect] = useState(null);
    const [sSelect, setsSelect] = useState(null);
    const [final, setFinal] = useState(null);
    const [selected, setSelected] = useState(null);
    const [votes, setVotes] = useState([]);
    const [steps, setSteps] = useState([]);
    const [modalArea, setModalArea] = useState();
    const [modalAreaId, setModalAreaId] = useState();
    const [showModal, setShowModal] = useState(false);

    var saveArea = useSelector((state) => state.questionnaireReducer.saveArea);
    var saveAreaError = useSelector((state) => state.questionnaireReducer.saveAreaError);

    useEffect(() => {
        if (saveArea) {
            localStorage.removeItem(variables.AREASSELCERVO)
            history.push("/admin/finish-cervo");
        }
    }, [saveArea])

    const goTo = (number) => {

        setStep(number)
    }

    useEffect(() => {
        let mData = localStorage.getItem(variables.AREASSELCERVO);
        if (mData && JSON.parse(mData)) {
            setSelected(JSON.parse(mData));
            let mVotes = [];
            let mPayload = {areas: JSON.parse(mData), questionnaire: "CERVO"}
            try {
                xcService.postToken("/v1/student/save/areatemp/", mPayload).then(data => {})
            }catch (e) {
                console.error(e)
            }
            JSON.parse(mData).map(item => {
                mVotes.push(0);
            })
            setVotes(mVotes);
            let mSteps = [];
            mSteps.push({h: 0, v: 1});
            mSteps.push({h: 0, v: 2});
            mSteps.push({h: 0, v: 3});
            mSteps.push({h: 1, v: 2});
            mSteps.push({h: 1, v: 3});
            mSteps.push({h: 2, v: 3});
            setSteps(mSteps);

        } else {
            history.push("/admin/end-cervo")
        }
    }, [])

    const getTitle = (subS) => {

        if (subStep < 6) {
            let mData = selected[subS];

            if (mData.isGoal){
                return mData.then;
            }else{
                return mData.like;
            }
            
        } else {
            return subS === 0 ? fSelect.then : sSelect.then
        }
    }

    const select = (subS) => {
        setVotes(votes => {
            return votes.map((item, j) => {
                return j === subS ? item + 1 : item
            })
        })

        setSubStep(subStep + 1)

    }
    const getFinal = () => {
        let mPos = -1;
        let mSuma = -1;
        votes.map((item, index) => {
            if (item > mSuma) {
                mSuma = item;
                mPos = index;
            }
        })


        return selected[mPos];
    }
    const getImg = (subS) => {
        if (subStep < 6) {
            let mData = selected[subS]

            return mData.image;
        } else {
            return subS === 0 ? fSelect.image : sSelect.image
        }
    }

    const selectFinal = (item) => {
        setFinal(item);
        setSubStep(3)
    }

    const reset = () => {
        setFinal(null);
        setStep(0);
        setSubStep(0);

    }

    const showAreaModal = (area) => {
        setModalArea(selected[area]);
        setModalAreaId(area);
        setShowModal(true);
    }

    const confirm = () => {
        let mPos = -1;
        let mSuma = -1;
        votes.map((item, index) => {
            if (item > mSuma) {
                mSuma = item;
                mPos = index;
            }
        })


        dispatch(questionnaireActions.saveArea({area_id: selected[mPos].id, questionnaire: "CERVO"}));
    }


    const saveAndContinue = () => {
        history.push("/admin/assessment")
    }
    return (
        <>
            {showModal &&
                <Modal className={"modalName modal-question"} title={modalArea.like}
                       centered
                       visible={showModal}
                       onCancel={()=>setShowModal(false)}
                >
                    <div className={"container-question"}>
                        <div className={"container-question__auto-margin"}>
                            <div className={"question__header"}>
                                <img className={"question__header-icon"} src={`/assets/img/ri${getImg(modalAreaId)}`}/>
                                <span className={"title"}>&nbsp;&nbsp;{modalArea.like}</span>
                            </div>
                            <div className={"question__content"}>
                                <div className={"question__content-mid"}>
                                    {modalArea.has &&
                                        <div className={"container-line"}>
                                            <img className={"container-line__icon"} src={have}/>
                                            <p className={"container-line__text"}>
                                                <strong>{t("ceiba.have")}</strong>&nbsp;
                                                {modalArea.has}
                                            </p>
                                        </div>
                                    }
                                    {modalArea.like &&
                                        <div className={"container-line"}>
                                            <img className={"container-line__icon"} src={like}/>
                                            <p className={"container-line__text"}>
                                                <strong>{t("ceiba.like")}</strong>&nbsp;
                                                {modalArea.like}
                                            </p>
                                        </div>
                                    }
                                    {modalArea.then &&
                                        <div className={"container-line"}>
                                            <img className={"container-line__icon"} src={then}/>
                                            <p className={"container-line__text"}>
                                                <strong>{t("ceiba.then")}</strong>&nbsp;
                                                {modalArea.then}
                                            </p>
                                        </div>
                                    }
                                    {modalArea.study &&
                                        <div className={"container-line"}>
                                            <img className={"container-line__icon"} src={study}/>
                                            <p className={"container-line__text"}>
                                                <strong>{t("ceiba.make")}</strong>&nbsp;
                                                {modalArea.study}
                                            </p>
                                        </div>
                                    }
                                    {modalArea.work &&
                                        <div className={"container-line"}>
                                            <img className={"container-line__icon"} src={work}/>
                                            <p className={"container-line__text"}>
                                                <strong>{t("ceiba.work")}</strong>&nbsp;
                                                {modalArea.work}
                                            </p>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
            }
            {step === -1 &&
                <div className={"containerStartCervoTwo containerStartCervoTwo--doors wrapper"}>
                    <div className={"boxed"}>
                        <div className={"insideCervo boxed addzIndex"} style={{zIndex: "400000 !importart"}} >

                            <Headerbutton noSave={true} saveAndContinue={saveAndContinue} />
                        </div>

                        <div className={"container-end-game"}>
                            <div className={"content-end-game content-end-game--first"}>
                                <div className={"content-end-game__center"}>
                                    <h1>{t("cervo.pasofinal")}</h1>

                                    <p dangerouslySetInnerHTML={{__html: t('cervo.pasofinal2')}}/>
                                </div>
                                <Button type={"primary"}
                                        onClick={() => goTo(0)}
                                        className="primaryButton">{t("vamos")}</Button>
                                <Button type="link"
                                        icon={<LeftOutlined/>}
                                        onClick={() => history.push("/admin/end-cervo")}
                                        className={"btn-back"}
                                >
                                    {t("atras")}
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            }

            {step === 0 &&

                <div className={"backGroundCervo backGroundCervo--game"}>
                    <div className={"wrapper-game boxed"}>
                        <div className={"insideCervo boxed addzIndex"} style={{zIndex: "400000 !importart"}} >

                            <Headerbutton  noSave={true} saveAndContinue={saveAndContinue} />
                        </div>
                        <div className={"container-info-end-game"}>
                            <div className={"content-info-end-game-l"}>
                                <p className={"end-game-text--strong"}>{t("cervo.pasofinalt")}</p>
                                <p>{t("cervo.dicotomia")}</p>
                            </div>
                            {subStep < 6 &&
                                <div className={"content-info-end-game-r"}>
                                    <Progress percent={(subStep * 100) / 5} showInfo={false}/>
                                    <p className={"end-game-text--strong"}>{t("fasesquedan")}: {subStep + 1}/6</p>
                                </div>
                            }
                        </div>
                        <div className={"container-end-game"}>
                            <div className={"content-end-game"}>
                                {subStep < 6 &&
                                    <>
                                        {!final && <h2 className={"title-fav"}>{t("cervo.cual")}</h2>}
                                        <div className={"content-game"}>
                                            <div className={"content-game-col"}>
                                                <div className={"info-area"}>
                                                    {/* ToDo : Open Modal info area*/}
                                                    <h3>{getTitle(steps[subStep].h)}<QuestionCircleOutlined onClick={()=>showAreaModal(steps[subStep].h)}/></h3>
                                                </div>
                                                <div className={"card-area"} onClick={() => select(steps[subStep].h)}>
                                                    <img className={"icon"}
                                                         src={`/assets/img/ri${getImg(steps[subStep].h)}`}/>
                                                    <p>{getTitle(steps[subStep].h)}</p>
                                                </div>
                                            </div>
                                            <div className={"content-game-col"}>
                                                <div className={"info-area"}>
                                                    {/* ToDo : Open Modal info area*/}
                                                    <h3>{getTitle(steps[subStep].v)}<QuestionCircleOutlined onClick={()=>showAreaModal(steps[subStep].v)}/></h3>

                                                </div>
                                                <div className={"card-area"} onClick={() => select(steps[subStep].v)}>
                                                    <img className={"icon"}
                                                         src={`/assets/img/ri${getImg(steps[subStep].v)}`}/>
                                                    <p>{getTitle(steps[subStep].v)}</p>
                                                </div>
                                            </div>
                                        </div>

                                    </>

                                }
                                {subStep > 5 &&
                                    <>
                                        <div className={"content-end-game__mid"}>
                                            <div className={"content-end-game__mid-l"}>
                                                <h2>{t("cervo.bienhecho")}</h2>
                                                <p>{user.name}{t("cervo.bienhecho2")}&nbsp;
                                                    <strong>{getFinal().like}</strong>
                                                </p>
                                                <p>{t("cervo.bienhecho3")}</p>
                                            </div>
                                            <div className={"content-end-game__mid-r"}>
                                                <img style={{width: 160, height: 160}}
                                                     src={`/assets/img/ri${getFinal().image}`}/>
                                                <h3>{getFinal().like}</h3>
                                            </div>
                                        </div>
                                        <div className={"content-end-game__bottom"}>
                                            <Button

                                                onClick={() => history.push("/admin/end-cervo")}

                                                className="primaryButton"
                                            >
                                                {t("cervo.modificar")}
                                            </Button>

                                            <Button

                                                onClick={() => confirm()}
                                                type={"primary"}
                                                className="primaryButton"
                                            >
                                                {t("cervo.confirmars")}
                                            </Button>
                                        </div>
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            }

        </>
    )
}

export default withTranslation()(CervoGame);
